import { render } from "./NcrmWorkflowStagingTable.vue?vue&type=template&id=5bc10534&scoped=true"
import script from "./NcrmWorkflowStagingTable.vue?vue&type=script&lang=js"
export * from "./NcrmWorkflowStagingTable.vue?vue&type=script&lang=js"

import "./NcrmWorkflowStagingTable.vue?vue&type=style&index=0&id=5bc10534&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc10534"]])

export default __exports__